// import  materialize from 'materialize-css/dist/css/materialize.min.css';
import "./components/matirialize-modal.css";
import "./components/matirialize-zoom.css";
import "./components/matirialize.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import store from "./store/index";
import { Provider } from "react-redux";
// import './fonts/Goldman/Goldman-Bold.ttf';
import './fonts/classic_font/Classic_Robot.otf';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("chatbot-root")
);

